import { useState, useEffect } from "react";
import { useAppServices } from "../../../hook/services";
import Swal from "sweetalert2";
import DataTable from "./components/DataTable";
import AddAppsModal from "./components/Modals/Create";
import EditAppsModal from "./components/Modals/Edit";
import { useNavigate } from "react-router-dom";

const ConversationProviders = () => {
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [processing, setProcessing] = useState(true);
  const [apps, setApps] = useState([]);
  const getData = async () => {
    const { response } = await AppService.apps.get();
    if (response) {
      setApps(response.data);
    } else {
      setApps([]);
    }
    setProcessing(false);
  };
  useEffect(() => {
    getData();
  }, []);
  const handleView = async (id) => {
    navigate(`./${id}`);
  };

  const columns = [
    {
      label: "App ID",
      accessor: "appId",
      sortable: true,
      renderCell: (row) => (
        <div className="d-flex align-items-center">
          <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
            <i className="bi bi-phone text-primary"></i>
          </div>
          <div className="fw-semibold text-dark">
            {row.appId || <span className="text-muted">Not specified</span>}
          </div>
        </div>
      ),
    },
    {
      label: "App Name",
      accessor: "appName",
      sortable: true,
      renderCell: (row) => (
        <span className="badge bg-light text-dark border px-3 py-2 rounded-pill">
          {row.appName || "-"}
        </span>
      ),
    },
    {
      label: "Actions",
      accessor: "actions",
      sortable: false,
      renderCell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button
            className="btn btn-outline-primary btn-sm rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "36px", height: "36px" }}
            onClick={() => handleView(row._id)}
          >
            <i className="bi bi-eye"></i>
          </button>
          <EditAppsModal handleRefresh={getData} app={row} />
          <button
            className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "36px", height: "36px" }}
            onClick={() => handleDelete(row._id)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This App and all its associated data will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const { response } = await AppService.apps.delete({
          query: `_id=${id}`,
        });

        if (response) {
          await Swal.fire("Deleted!", "App has been deleted.", "success");
          getData();
        }
      } catch (error) {
        Swal.fire("Error!", "Something went wrong.", "error");
      }
    }
  };

  if (processing) {
    return (
      <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
        <div className="container-fluid p-4">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <div className="text-center">
              <div
                className="spinner-border text-primary mb-3"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted">Loading Apps...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
      <div className="container-fluid p-4">
        {/* Header Card */}
        <div
          className="card border-0 shadow-sm mb-4"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body py-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1 fw-bold text-dark">Apps</h4>
                <p className="text-muted mb-0 small">Manage your Apps</p>
              </div>
              <AddAppsModal handleRefresh={getData} />
            </div>
          </div>
        </div>

        <DataTable columns={columns} data={apps} entriesPerPage={10} />
      </div>
    </div>
  );
};

export default ConversationProviders;
